import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import {
  FormGroup,
  Form,
  Input,
  Label,
  Button,
  Spinner,
  InputGroupText,
  InputGroup,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { Container } from './style';
import { api } from './../../services/api';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { HiOutlineLockClosed, HiOutlineLockOpen, HiOutlineUserCircle } from 'react-icons/hi';
import './style.css';
import { BsPerson } from 'react-icons/bs';
import { MdOutlineVpnKey } from 'react-icons/md';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export const ResetPassword = (props): React.JSX.Element => {
  const history = useHistory();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [passwordSuccessfullyUpdated, setPasswordSuccessfullyUpdated] = useState(false);
  const [errorEmail, setErrorEmail] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const [errorPasswordConfirmation, setErrorPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  // const { signIn, loading } = useAuth();
  async function handleSubmitLogin(): Promise<void> {
    if (email.length < 1) {
      setErrorEmail('Email obrigatório.');
    } else if (!email.includes('@')) {
      setErrorEmail('É necessário um email válido.');
    } else if (email.split('@')[1] === '') {
      setErrorEmail('É necessário um email válido.');
    } else {
      setErrorEmail('');
    }

    if (password.length < 1) {
      setErrorPassword('Senha obrigatória.');
    } else if (password !== passwordConfirmation) {
      setErrorPassword('É necessário que as senhas sejam iguais.');
    } else {
      setErrorPassword('');
    }
    if (passwordConfirmation.length < 1) {
      setErrorPasswordConfirmation('Confirmação de senha obrigatória.');
    } else if (password !== passwordConfirmation) {
      setErrorPasswordConfirmation('É necessário que as senhas sejam iguais.');
    } else {
      setErrorPasswordConfirmation('');
    }
    // if (cpf.length === 14 && password !== '' && password.length >= 8) {
    if (
      email.length !== 0 &&
      password.length !== 0 &&
      passwordConfirmation.length !== 0 &&
      password === passwordConfirmation &&
      email.includes('@') &&
      email.split('@')[1].length > 1
    ) {
      await resetPassword();
    }
  }
  // useEffect(() => {
  //   setCPF(localStorage.getItem('inputValueCpf') as unknown as string);
  //   setPassword(localStorage.getItem('inputValuePassword') as unknown as string);
  // }, []);

  async function resetPassword(): Promise<void> {
    try {
      setLoading(true);
      const resetPassword = await api.post('auth/reset-password', {
        email,
        newPassword: password,
        resetToken: props?.match?.params?.token,
      });
      toast('Senha alterada com sucesso!', { type: 'success' });
      setLoading(false);
      setPasswordSuccessfullyUpdated(true);
      // history.push('/login');
    } catch (error) {
      setLoading(false);
      // @ts-expect-error error
      if (error?.response?.status === 400) {
        toast('Email não encontrado!', { type: 'error' });
        console.log(error);
      } else {
        toast('Um erro foi encontrado, contate o administrador do sistema, ou tente novamente', {
          type: 'error',
        });
        console.log(error);
      }
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: '#edf3ff',
      }}
    >
      {/* Imagem lateral */}
      <div
        className="d-none d-md-block"
        style={{
          width: '50%',
          height: '100vh',
        }}
      >
        <img
          src="/assets/sideImage.png"
          alt="icone-amapa"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </div>

      {/* Formulário */}
      <div
        className="col-sm"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <div
          className="col-sm-7"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 20,
            height: '100%',
            marginTop: -90,
          }}
        >
          {/* Logo */}
          <div>
            <img
              src="/assets/logo.png"
              alt="icone-amapa"
              className="logo"
              // style={{
              //   width: '100%', // ocupa todo o espaço possível
              //   maxWidth: '330px', // não passa disso
              //   height: 'auto', // mantém proporção
              //   objectFit: 'cover',
              // }}
            />
          </div>

          {/* Card do formulário */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#fff',
              borderRadius: 12,
              padding: '30px 20px',
              width: '100%',
              maxWidth: 562,
              minHeight: 456,
              gap: 20,
              maxHeight: '80vh', // altura máxima relativa à tela
              overflowY: 'auto', // ativa scroll interno quando necessário
            }}
          >
            <div style={{ marginBottom: 25, textAlign: 'center' }}>
              <h5 style={{ fontWeight: 500, fontSize: 45 }}>Redefinição de senha!</h5>
              <span>Preencha os campos para redefinição de senha.</span>
            </div>

            <Form style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  {/* <Label
                    style={{
                      fontWeight: 'bold',
                      color: errorEmail?.length > 1 ? '#E44B39' : '#2C2C2D',
                    }}
                  >
                    Email
                  </Label> */}{' '}
                  <InputGroup>
                    <InputGroupText
                      className="no-border-right"
                      style={{
                        backgroundColor: 'transparent', // fundo transparente
                        color: '#2A2C85', // cor do ícone
                        borderRight: 'none', // remove a borda da direita
                        borderColor: errorEmail?.length > 1 ? '#E44B39' : '#989898',
                      }}
                    >
                      <BsPerson /> {/* ícone react-icons */}
                    </InputGroupText>
                    <Input
                      className="no-border-left"
                      style={{
                        borderColor: errorEmail?.length > 1 ? '#E44B39' : '#989898',
                        height: 48,
                      }}
                      id="exampleEmail"
                      name="email"
                      value={email}
                      placeholder="Insira seu email"
                      type="text"
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </InputGroup>
                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorEmail}
                  </text>
                </FormGroup>{' '}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  {/* <Label
                    style={{
                      fontWeight: 'bold',
                      color: errorPassword?.length > 1 ? '#E44B39' : '#2C2C2D',
                    }}
                  >
                    Nova senha
                  </Label> */}{' '}
                  <InputGroup>
                    <InputGroupText
                      className="no-border-right"
                      style={{
                        backgroundColor: 'transparent', // fundo transparente
                        color: '#2A2C85', // cor do ícone
                        borderRight: 'none', // remove a borda da direita
                        borderColor: errorPassword?.length > 1 ? '#E44B39' : '#989898',
                      }}
                    >
                      <MdOutlineVpnKey />
                    </InputGroupText>
                    <Input
                      className="no-border-left-password"
                      style={{
                        borderColor: errorPassword?.length > 1 ? '#E44B39' : '#989898',
                        height: 48,
                      }}
                      id="exampleEmail"
                      name="email"
                      value={password}
                      placeholder="Insira a nova senha"
                      type="password"
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />{' '}
                    <InputGroupText
                      style={{
                        backgroundColor: 'transparent', // fundo transparente
                        color: '#2A2C85', // cor do ícone
                        cursor: 'pointer',
                        borderLeft: 'none',
                        borderColor: errorPassword?.length > 1 ? '#E44B39' : '#989898',
                      }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash color="#C6C6C6" /> : <FaEye color="#C6C6C6" />}
                    </InputGroupText>
                  </InputGroup>
                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorPassword}
                  </text>
                </FormGroup>{' '}
              </div>{' '}
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  {/* <Label
                    style={{
                      fontWeight: 'bold',
                      color: errorPasswordConfirmation?.length > 1 ? '#E44B39' : '#2C2C2D',
                    }}
                  >
                    Confirmar nova senha
                  </Label> */}
                  <InputGroup>
                    <InputGroupText
                      className="no-border-right"
                      style={{
                        backgroundColor: 'transparent', // fundo transparente
                        color: '#2A2C85', // cor do ícone
                        borderRight: 'none', // remove a borda da direita
                        borderColor: errorPasswordConfirmation?.length > 1 ? '#E44B39' : '#989898',
                      }}
                    >
                      <MdOutlineVpnKey />
                    </InputGroupText>
                    <Input
                      className="no-border-left-password"
                      style={{
                        borderColor: errorPasswordConfirmation?.length > 1 ? '#E44B39' : '#989898',
                        height: 48,
                      }}
                      id="exampleEmail"
                      name="email"
                      value={passwordConfirmation}
                      placeholder="Confirme a nova senha"
                      type="password"
                      onChange={(e) => {
                        setPasswordConfirmation(e.target.value);
                      }}
                    />{' '}
                    <InputGroupText
                      style={{
                        backgroundColor: 'transparent', // fundo transparente
                        color: '#2A2C85', // cor do ícone
                        cursor: 'pointer',
                        borderLeft: 'none',
                        borderColor: errorPasswordConfirmation?.length > 1 ? '#E44B39' : '#989898',
                      }}
                      onClick={() => setShowPassword2(!showPassword2)}
                    >
                      {showPassword2 ? <FaEyeSlash color="#C6C6C6" /> : <FaEye color="#C6C6C6" />}
                    </InputGroupText>
                  </InputGroup>
                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorPasswordConfirmation}
                  </text>
                </FormGroup>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  disabled={loading}
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onClick={async () => {
                    await handleSubmitLogin();
                  }}
                  style={{
                    width: '100%',
                    maxWidth: 452,
                    backgroundColor: '#2A2C85',
                    color: '#fff',
                    height: 48,
                  }}
                  color="success"
                  size="md"
                >
                  {loading ? <Spinner type="border" size={'sm'} color="light" /> : 'Enviar'}
                </Button>{' '}
              </div>
            </Form>
          </div>
        </div>
      </div>
      {/* {passwordSuccessfullyUpdated ? (
        <Container>
          <div className="login-form">
            <div
              style={{
                justifyContent: 'center',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                  margin: 'auto',
                  position: 'absolute',
                  backgroundColor: '#F0EFF5',
                }}
              >
                <div
                  className="content"
                  style={{
                    border: '1px solid rgba(0, 0, 0, 0.05)',
                    padding: 50,
                    borderRadius: 8,
                    backgroundColor: '#fff',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 25 }}>
                    <HiOutlineLockClosed size={150} color={'#005675'} />
                  </div>
                  <h4>Processo de redefinição de senha completo.</h4>
                </div>
              </div>
            </div>
          </div>
        </Container>
      ) : (
        <Container>
          <div className="login-form">
            <div
              style={{
                justifyContent: 'center',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                  margin: 'auto',
                  position: 'absolute',
                }}
              >
                <div className="content">
                  <Form style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <FormGroup>
                      <p style={{ textAlign: 'center', fontSize: 17, width: '100%' }}>
                        Preencha os campos para redefinição de senha.
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        style={{
                          fontWeight: 'bold',
                          color: errorEmail?.length > 1 ? '#E44B39' : '#2C2C2D',
                        }}
                      >
                        Email
                      </Label>
                      <Input
                        style={{ borderColor: errorEmail?.length > 1 ? '#E44B39' : '#989898' }}
                        id="exampleEmail"
                        name="email"
                        value={email}
                        placeholder="Insira seu email"
                        type="text"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <text
                        style={{
                          fontSize: 14,
                          color: '#E44B39',
                          marginBottom: 5,
                        }}
                      >
                        {errorEmail}
                      </text>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        style={{
                          fontWeight: 'bold',
                          color: errorPassword?.length > 1 ? '#E44B39' : '#2C2C2D',
                        }}
                      >
                        Nova senha
                      </Label>
                      <Input
                        style={{ borderColor: errorPassword?.length > 1 ? '#E44B39' : '#989898' }}
                        id="exampleEmail"
                        name="email"
                        value={password}
                        placeholder="Insira a nova senha"
                        type="password"
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />
                      <text
                        style={{
                          fontSize: 14,
                          color: '#E44B39',
                          marginBottom: 5,
                        }}
                      >
                        {errorPassword}
                      </text>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        style={{
                          fontWeight: 'bold',
                          color: errorPasswordConfirmation?.length > 1 ? '#E44B39' : '#2C2C2D',
                        }}
                      >
                        Confirmar nova senha
                      </Label>
                      <Input
                        style={{
                          borderColor:
                            errorPasswordConfirmation?.length > 1 ? '#E44B39' : '#989898',
                        }}
                        id="exampleEmail"
                        name="email"
                        value={passwordConfirmation}
                        placeholder="Confirme a nova senha"
                        type="password"
                        onChange={(e) => {
                          setPasswordConfirmation(e.target.value);
                        }}
                      />
                      <text
                        style={{
                          fontSize: 14,
                          color: '#E44B39',
                          marginBottom: 5,
                        }}
                      >
                        {errorPasswordConfirmation}
                      </text>
                    </FormGroup>

                    <Button
                      disabled={loading}
                      // eslint-disable-next-line @typescript-eslint/no-misused-promises
                      onClick={async () => {
                        await handleSubmitLogin();
                      }}
                      style={{ width: '100%' }}
                      color="success"
                      size="md"
                    >
                      {loading ? <Spinner type="border" size={'sm'} color="light" /> : 'Enviar'}
                    </Button>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </Container>
      )} */}
    </div>
  );
};
